
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Preview, Note } from "@lighting-beetle/lighter-styleguide";

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1>{`Typography`}</h1>
    <h2>{`Headings`}</h2>
    <p>{`There are four main headlines: h1-h5.`}</p>
    <Note title="Tag mismatch" mdxType="Note">
  In case that html tag mismatch style of headline, you can use classes .h1 -
  .h5.
    </Note>
    <Preview mdxType="Preview">
  <h1>Headline 1: Lorem ipsum</h1>
  <h2>Headline 2: Lorem ipsum Dolore eiusmod.</h2>
  <h3>Headline 3: Lorem ipsum Cupidatat irure dolor est.</h3>
  <h4>Headline 4: Lorem ipsum In laborum consequat amet aute dolor.</h4>
  <h5>Headline 5: Lorem ipsum Dolor quis adipisicing in in minim.</h5>
  <h6>Headline 6: Lorem ipsum Adipisicing adipisicing occaecat laborum.</h6>
    </Preview>
    <h2>{`Text`}</h2>
    <p>{`There are styles for default text, hero-text, description text and small text.`}</p>
    <Preview mdxType="Preview">
  <p className="text-big">
    <strong>Hero text:</strong> Lorem ipsum Dolor quis adipisicing in in minim
    laborum adipisicing eu irure voluptate quis dolore sit cillum minim in
    adipisicing adipisicing occaecat laborum.
  </p>
  <p>
    <strong>Body text:</strong> Lorem ipsum{" "}
    <a className="link">Ullamco voluptate</a> veniam consectetur mollit
    adipisicing labore cupidatat ad in dolore consectetur culpa sit Duis
    cupidatat Duis laboris <a className="link">voluptate</a> est nulla enim
    laboris sit sint deserunt ullamco in fugiat dolor ullamco esse id ut{" "}
    <em>aliqua labore</em> pariatur lcommodo consectetur reprehenderit minim{" "}
    <strong>consectetur incididunt</strong> adipisicing deserunt pariatur non
    eiusmod velit ut quis aliquip qui occaecat in ex in adipisicing sunt.
  </p>
  <p className="text-desc">
    <strong>Description text:</strong> Lorem ipsum Sed dolor magna cillum
    aliquip adipisicing occaecat nisi veniam deserunt est magna qui consequat Ut
    enim commodo laboris reprehenderit eu nostrud et tempor velit.
  </p>
  <p className="text-small">
    <strong>Small text:</strong> Lorem ipsum Dolore veniam in ex ut culpa sunt
    incididunt aliquip et eu consectetur culpa quis elit anim magna enim dolor
    dolor officia occaecat sed tempor irure fugiat ullamco et laboris
    reprehenderit amet tempor sit nulla ut proident ex exercitation veniam.
  </p>
  <hr />
  <blockquote>
    Oh, nothing, Tommy. It{"'"}s tip-top. It{"'"}s just I{"'"}m not sure about
    the colour.
    <cite>Turkish</cite>
  </blockquote>
    </Preview>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;